<div class="contenedor-tabla">
    <mat-table
        class="facturas-tabla"
        #table
        [dataSource]="dataSource"
        matSort
        matSortActive="numero"
        matSortDisableClear
        matSortDirection="desc"
        [@animateStagger]="{ value: '50' }"
        fusePerfectScrollbar
    >
        <ng-container matColumnDef="numero">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Nro.. Factura</mat-header-cell
            >
            <mat-cell *matCellDef="let factura">
                <!--<p>
                    <strong>{{ pedido.nroOOTT }} </strong>
                </p>-->
                <a [routerLink]="'/facturas/' + factura.idFactura">
                    {{ factura.numero }}
                </a>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estado">
            <mat-header-cell *matHeaderCellDef>Estado</mat-header-cell>
            <mat-cell *matCellDef="let factura">
                <p>
                    <span class="cursor-pointer">
                        <strong>{{
                            factura.pagada ? "Pagada" : "Impaga"
                        }}</strong>
                    </span>
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fecha">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Fecha</mat-header-cell
            >
            <mat-cell *matCellDef="let factura">
                <p>
                    {{ factura.fecha | date: "dd-MM-YYYY HH:mm" }}
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="montoBrutoClp">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Total</mat-header-cell
            >
            <mat-cell *matCellDef="let factura">
                <p>
                    {{
                        factura.montoBrutoCLP | currency: "CLP":"symbol-narrow"
                    }}
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cliente.nrRut">
            <mat-header-cell
                class="column-cliente"
                *matHeaderCellDef
                mat-sort-header
                >Rut</mat-header-cell
            >
            <mat-cell class="column-cliente" *matCellDef="let factura">
                <p>{{ factura.cliente.nrRut }} - {{ factura.cliente.dv }}</p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cliente.nombre">
            <mat-header-cell
                class="column-cliente"
                *matHeaderCellDef
                mat-sort-header
                >Cliente</mat-header-cell
            >
            <mat-cell class="column-cliente" *matCellDef="let factura">
                <p>
                    {{ factura.cliente.nombre }}
                </p>
            </mat-cell>
        </ng-container>

        <mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row *matRowDef="let factura; columns: displayedColumns"> </mat-row>
    </mat-table>

    <mat-paginator
        #paginator
        [length]="resultsLength"
        [pageIndex]="0"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 25, 100]"
    >
    </mat-paginator>
</div>
